
import React from 'react';
import ChartIdeas from './components/ChartIdeas/ChartIdeas';

const ChartI = () => {
    return (
        <div>
            <ChartIdeas/>
        </div>
    );
};

export default ChartI;